import Column from "@amzn/meridian/column";
import Tooltip from "@amzn/meridian/tooltip";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import React from "react";
import Alert from "@amzn/meridian/alert"

import {BAG_TRACKING_CONSTANTS} from "../../util/Constants";

/** StageStatusView publishes Bag information metrics such as total bags, bags outside of station **/
export const StageStatusView = (data) => {
    const stageStatus = data.stageStatus ? data.stageStatus : {};
    return (
        <Column spacing="small">
            <Tooltip position="right" title={stageStatus.tooltip ? stageStatus.tooltip : ""}>
                <Text type="h100">
                    <b><FormattedMessage id={stageStatus.title ? stageStatus.title : ""} defaultMessage={stageStatus.message ? stageStatus.message : ""}/></b>
                </Text>
            </Tooltip>
            <Text type="d50">{data.stageStatus.value}</Text>
        </Column>
    )
};

/** ScrollableElementWrapper allows a scrolling mechanism to be provided for overflowing boxes for it's children **/
export const ScrollableElementWrapper = ({children}) => (
    <div style={{ overflowX: "auto", width: "100%" }}>
        {children}
    </div>
);

/** Filters the bags based on departed time. It takes last 1 day as default filter. **/
export const filterBagInfoByDepartTime = (bagInfo, filters) => {
    const startDate = filters.startDate.split('-');
    const startTime = filters.startTime.split(':');
    const starTimeStamp = new Date(Date.UTC(startDate[0], startDate[1]-1, startDate[2], startTime[0], startTime[1], startTime[2]));
    return filters.length === 0 || (bagInfo['departEventTime'] && bagInfo['departEventTime'] >= starTimeStamp);
};

export const filterBagInfo = (bagInfo, filter, key) => {
    return filter.length === 0 || (bagInfo[key] && bagInfo[key].toString().toLowerCase().startsWith(filter.toLowerCase()));
};

/** TimeStamp to Human Readable date time **/
export const convertTimestampToLocaleString = (dateTimeStamp, bagStatus, useCase) => {
    /**
     * Don't convert null or undefined timestamp into string.
     * Show both depart and receive time when bag is inside station but only show depart time if bag is outside station.
     */
    if (dateTimeStamp == null ||
        (bagStatus === BAG_TRACKING_CONSTANTS.OUTSIDE_STATION && useCase === BAG_TRACKING_CONSTANTS.RECEIVE_TIME)) {
        return;
    }
    return new Date(dateTimeStamp).toLocaleString();
};

/** Set Bag Status. This function converts bag's event type into a more user friendly format. If event type is RECEIVE, then
 * it indicates that bag is received at the station which means currently the bag is inside the station. Similarly, if event
 * type i depart, then it indicates that bag is departed from the station which means currently bag is outside of the station.
 **/
export const setBagStatus = (bag) => {
    if (bag.eventType === BAG_TRACKING_CONSTANTS.RECEIVE) {
        bag.eventType = BAG_TRACKING_CONSTANTS.INSIDE_STATION
    } else if (bag.eventType === BAG_TRACKING_CONSTANTS.DEPART) {
        bag.eventType = BAG_TRACKING_CONSTANTS.OUTSIDE_STATION
    }
};

export const BagTrackingBanner = () => {
    return(
        <Column>
            <Alert size="large">
                <FormattedMessage id="banner.bagTracking"/>
            </Alert>
        </Column>
    )
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/bagtracking/BagTrackingUtil.js